export { ModalBase, ModalBaseDefaultProps } from './modal-base';
export type { ModalBaseSettings, ModalBaseStylesNames, ModalBaseProps } from './modal-base';
export type { ModalBaseBodyProps } from './modal-base-body/modal-base-body';
export type { ModalBaseCloseButtonProps } from './modal-base-close-button/modal-base-close-button';
export type { ModalBaseContentProps } from './modal-base-content/modal-base-content';
export type { ModalBaseHeaderProps } from './modal-base-header/modal-base-header';
export type { ModalBaseOverlayProps } from './modal-base-overlay/modal-base-overlay';
export type { ModalBaseTitleProps } from './modal-base-title/modal-base-title';
